<template>
  <div class="psychological-page">
    <!-- 1. Banner 区域 (深色) -->
   <section class="lib-banner">
  <div class="banner-overlay"></div>
  <div class="container">
    <div class="banner-content">
      <h1>AI数字人<br>心理咨询系统</h1>
      <p class="subtitle">懂你的AI心理咨询师，守护每一颗心灵</p>
      <p class="banner-desc">融合人工智能与心理学专业知识，提供全天候、个性化、安全可靠的心理健康服务，助力高校构建智慧心理育人新生态</p>
      <button class="btn-primary" @click="contactUs">
        合作咨询 <span class="divider">|</span> 020-82038386
      </button>
    </div>
  </div>
</section>

    <!-- 2. AI赋能专业心理服务 -->
    <section class="ai-services">
      <div class="container">
        <div class="section-title">
          <h2>AI赋能专业心理服务</h2>
          <p>以专业心理学知识与AI技术深度融合，构建从预防、评估、干预到支持的全流程心理健康服务体系。</p>
        </div>
        <div class="services-grid">
          <div class="service-card" v-for="service in aiServices" :key="service.id">
            <div class="service-icon-wrapper">
              <img :src="service.icon" :alt="service.title" class="service-icon">
            </div>
            <h4>{{ service.title }}</h4>
            <p>{{ service.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 3. 软硬件一体化智能交互终端 -->
    <section class="hardware-terminal">
      <div class="container">
        <div class="section-title">
          <h2>软硬件一体化智能交互终端</h2>
          <p>AI数字人面对面，沟通更自然</p>
        </div>
        <div class="terminal-layout">
          <!-- 左侧功能点 -->
          <div class="terminal-features left-features">
            <div class="feature-item" v-for="(feature, index) in leftFeatures" :key="index">
              <div class="feature-box">
                <img :src="feature.icon" :alt="feature.title" class="feature-icon">
                <div class="feature-text">
                  <h4>{{ feature.title }}</h4>
                  <p>{{ feature.desc }}</p>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 中间设备图 -->
          <div class="terminal-device">
            <img :src="terminalDeviceImage" alt="智能交互终端" class="device-main">
          </div>
          
          <!-- 右侧功能点 -->
          <div class="terminal-features right-features">
            <div class="feature-item" v-for="(feature, index) in rightFeatures" :key="index">
              <div class="feature-box">
                <img :src="feature.icon" :alt="feature.title" class="feature-icon">
                <div class="feature-text">
                  <h4>{{ feature.title }}</h4>
                  <p>{{ feature.desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 4. 心理咨询室落地部署方案 -->
   <!-- <section class="deployment-plan">
  <div class="container">
    <div class="section-title">
      <h2>心理咨询室落地部署方案</h2>
      <p>专业空间设计 · 标准化建设 · 可持续运营</p>
    </div>
    <div class="deployment-steps">
      <template v-for="(step, index) in deploymentSteps" :key="index">
        <div class="step-item">
          <div class="step-icon-wrapper">
            <div class="icon-circle">
              <img :src="step.icon" :alt="step.title" class="step-icon">
            </div>
          </div>
          <h4>{{ step.title }}</h4>
          <p>{{ step.desc }}</p>
        </div>
        <div v-if="index < deploymentSteps.length - 1" class="step-arrow">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </template>
    </div>
  </div>
</section> -->
<section class="cc-deployment">
  <div class="container">
    <div class="section-title">
      <h2>心理咨询室落地部署方案</h2>
      <p>专业空间设计 · 标准化建设 · 可持续运营</p>
    </div>
    <div class="deploy-steps">
      <template v-for="(step, index) in deploymentSteps" :key="index">
        <div class="step-item" >
          <div class="step-icon-box">
            <!-- 请在此处引入您的小图标 -->
            <img :src="step.icon" :alt="step.title" class="step-icon">
          </div>
          <h4>{{ step.title }}</h4>
          <p>{{ step.desc }}</p>
        </div>
        <!-- 箭头：最后一个元素后不显示 -->
        <div class="step-arrow" v-if="index < deploymentSteps.length - 1" :key="'arrow-'+index">→</div>
      </template>
    </div>
  </div>
</section>
    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回产品矩阵</button>
  </div>
</template>

<script>
import AppFooter from './AppFooter.vue'

export default {
  name: 'AIPsychological',
  components: { AppFooter },
  data() {
    return {
      bannerDeviceImage: require('@/assets/images/class-card-banner-bg.png'),
      terminalDeviceImage: require('@/assets/images/class-card-device.png'),
      aiServices: [
        {
          id: 1,
          title: '智能对话情绪疏导',
          desc: '自然语言理解与共情对话，识别情绪状态，提供科学的疏导建议与支持。',
          icon: require('@/assets/images/feature-screen.png')
        },
        {
          id: 2,
          title: '专业心理测评量表',
          desc: '内置多种权威心理量表，科学评估心理状态，生成个性化报告与建议。',
          icon: require('@/assets/images/feature-screen.png')
        },
        {
          id: 3,
          title: '隐私加密安全保护',
          desc: '多重加密与权限管理，严格保护学生隐私，数据安全可控。',
          icon: require('@/assets/images/feature-screen.png')
        },
        {
          id: 4,
          title: '危机预警干预机制',
          desc: 'AI智能识别风险信号，多级预警与人工介入，及时干预，守护安全。',
          icon: require('@/assets/images/feature-screen.png')
        }
      ],
      leftFeatures: [
        {
          title: '高清触控大屏',
          desc: '沉浸式交互体验',
          icon: require('@/assets/images/screen-icon.png')
        },
        {
          title: 'AI数字人',
          desc: '自然拟人沟通',
          icon: require('@/assets/images/screen-icon.png')
        },
        {
          title: '情绪识别',
          desc: '表情与语音分析',
          icon: require('@/assets/images/screen-icon.png')
        }
      ],
      rightFeatures: [
        {
          title: '隐私保护设计',
          desc: '防窥屏&数据加密',
          icon: require('@/assets/images/screen-icon.png')
        },
        {
          title: '多模态交互',
          desc: '语音/文字/表情',
          icon: require('@/assets/images/screen-icon.png')
        },
        {
          title: '数据安全存储',
          desc: '本地化/私有化部署',
          icon: require('@/assets/images/screen-icon.png')
        }
      ],
      deploymentSteps: [
        {
          title: '需求调研',
          desc: '深入了解学校需求',
          icon: require('@/assets/images/step1.png')
        },
        {
          title: '方案设计',
          desc: '空间与系统整体规划',
          icon: require('@/assets/images/step2.png')
        },
        {
          title: '设备安装',
          desc: '软硬件部署与调试',
          icon: require('@/assets/images/step3.png')
        },
        {
          title: '系统上线',
          desc: '操作培训+上线支持',
          icon: require('@/assets/images/step4.png')
        },
        {
          title: '运营支持',
          desc: '持续优化服务支持',
          icon: require('@/assets/images/step4.png')
        }
      ]
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    contactUs() {
      // 联系我们的逻辑
      window.location.href = 'tel:020-82038386'
    }
  }
}
</script>

<style scoped>
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px;
}

/* 1. Banner (深色背景图) */
.lib-banner {
  position: relative;
  /* 左侧留白区域的背景色（与图片左侧浅色融合） */
  background-color: #e8f4f8;
  background-image: url('../assets/images/psychological-bg.png');
  /* 关键：高度100%填满容器，宽度自动按比例缩放 */
  background-size: auto 100%;
  /* 靠右对齐，人物在右侧完整显示 */
  background-position: right center;
  background-repeat: no-repeat;
  color: #1e293b;
  padding: 0;
  height: 580px; /* 固定高度，不占满屏幕 */
  display: flex;
  align-items: center;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 左侧白色遮罩，右侧透明显示人物 */
  background: linear-gradient(
    to right, 
    #ffffff 0%, 
    #ffffff 20%,
    rgba(255, 255, 255, 0.8) 35%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 65%
  );
  z-index: 1;
}

.lib-banner .container { 
  position: relative;
  display: flex; 
  align-items: center; 
  justify-content: flex-start;
  width: 100%;
  max-width: 1400px; /* 内容最大宽度 */
  margin: 0 auto;
  padding: 0 5%;
  z-index: 2;
}

.banner-content { 
  max-width: 550px;
}

.banner-content h1 { 
  font-size: 52px; 
  line-height: 1.2; 
  margin-bottom: 20px; 
  font-weight: 800;
  color: #0f172a;
}

.subtitle { 
  font-size: 22px; 
  color: #334155; 
  margin-bottom: 20px; 
  font-weight: 600;
}

.banner-desc {
  font-size: 15px;
  color: #64748b;
  line-height: 1.8;
  margin-bottom: 32px;
  max-width: 480px;
}

.btn-primary { 
  background: #0ea5e9;
  color: #fff; 
  border: none; 
  padding: 14px 32px;
  border-radius: 30px; 
  font-size: 16px; 
  cursor: pointer; 
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.btn-primary:hover { 
  background: #0284c7;
  transform: translateY(-2px);
}

.divider {
  opacity: 0.6;
  margin: 0 4px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .lib-banner {
    height: 500px;
  }
  .banner-content h1 { font-size: 44px; }
}

@media (max-width: 992px) {
  .lib-banner {
    height: 450px;
    /* 小屏幕图片缩小显示 */
    background-size: auto 100%;
  }
  .banner-content h1 { font-size: 36px; }
  .subtitle { font-size: 18px; }
  .banner-overlay {
    background: rgba(255, 255, 255, 0.85);
  }
}

@media (max-width: 768px) {
  .lib-banner {
    height: 400px;
  }
  .banner-content h1 { font-size: 28px; }
  .subtitle { font-size: 16px; }
  .banner-desc { font-size: 13px; }
}
/* 2. AI赋能专业心理服务 */
.ai-services {
  padding: 100px 0;
  background: #fff;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 32px;
  color: #1e293b;
  margin-bottom: 16px;
  font-weight: bold;
}

.section-title p {
  color: #64748b;
  font-size: 16px;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.service-card {
  background: #f8fafc;
  padding: 40px 30px;
  border-radius: 12px;
  text-align: center;
  border: 2px dashed #d0e4f5;
  transition: all 0.3s;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.service-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.service-card h4 {
  font-size: 18px;
  color: #1e293b;
  margin-bottom: 12px;
  font-weight: 600;
}

.service-card p {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

/* 3. 软硬件一体化智能交互终端 */
.hardware-terminal {
  padding: 100px 0;
  background: #f0f7fb;
}

.terminal-layout {
  display: grid;
  grid-template-columns: 1fr 400px 1fr;
  gap: 40px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.terminal-features {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.feature-item {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.feature-box {
  display: flex;
  align-items: center;
  gap: 16px;
}

.feature-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.feature-text h4 {
  font-size: 16px;
  color: #1e293b;
  margin-bottom: 4px;
  font-weight: 600;
}

.feature-text p {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

.terminal-device {
  display: flex;
  justify-content: center;
  align-items: center;
}

.device-main {
  max-width: 100%;
  height: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
}

/* 4. 心理咨询室落地部署方案 */
.cc-deployment { 
  padding: 80px 0; 
  background: #fff; 
}

.cc-deployment .section-title h2 {
  color: #1e293b;
  font-size: 32px;
  margin-bottom: 10px;
}

.deploy-steps { 
  display: flex; 
  justify-content: center; /* 居中排列 */
  align-items: flex-start;
  position: relative;
  margin-top: 50px;
  gap: 30px; /* 步骤之间的间距 */
}

.step-item { 
  flex: 1; 
  text-align: center; 
  max-width: 160px; /* 限制宽度防止太宽 */
}

/* 蓝色圆形图标背景 */
.step-icon-box {
  width: 64px;
  height: 64px;
  background: #1995d3; /* 深蓝色背景 */
  border-radius: 50%;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 4px 10px rgba(37, 99, 235, 0.2); */
}

.step-icon {
  width: 64px;
  height: 64px;
  object-fit: contain;
  /* 如果图标是白色的，不需要滤镜；如果是黑色的，可以加 filter: brightness(0) invert(1); */
}

.step-item h4 { 
  color: #1e293b; 
  font-size: 16px; 
  margin-bottom: 8px;
  font-weight: 600;
}

.step-item p {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

/* 箭头样式 */
.step-arrow {
  color: #94a3b8; /* 浅灰色箭头 */
  font-size: 24px;
  font-weight: bold;
  margin-top: 15px; /* 微调垂直位置，对齐图标中心 */
  flex-shrink: 0;
}

/* 响应式 */
@media (max-width: 992px) {
  .deploy-steps {
    flex-wrap: wrap;
    gap: 30px;
  }
  .step-arrow {
    display: none; /* 手机端隐藏箭头或改为向下 */
  }
  .step-item {
    flex: 0 0 45%;
  }
}

/* 返回按钮 */
.back-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #1e293b;
  color: #fff;
  border: none;
  padding: 15px 30px;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  font-size: 16px;
  transition: all 0.3s;
}

.back-btn:hover {
  background: #334155;
  transform: translateY(-2px);
}

/* 响应式 */
@media (max-width: 1200px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .terminal-layout {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .terminal-features {
    order: 2;
  }
  
  .terminal-device {
    order: 1;
  }
  
  .deployment-steps {
    flex-direction: column;
    gap: 40px;
  }
  
  .step-arrow {
    display: none;
  }
}

@media (max-width: 992px) {
  .banner-content h1 {
    font-size: 40px;
  }
  
  .subtitle {
    font-size: 20px;
  }
  
  .banner-overlay {
    right: 0;
  }
  
  .banner-device {
    display: none;
  }
}

@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 32px;
  }
  
  .subtitle {
    font-size: 18px;
  }
  
  .section-title h2 {
    font-size: 26px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
  }
  
  .feature-box {
    flex-direction: column;
    text-align: center;
  }
}
</style>